import { api } from "@/lib/api";
import { unwrapPage } from "@/lib/paging";

/** Largest export in one go; a bigger list says so instead of silently stopping */
export const EXPORT_LIMIT = 2000;

/** Every row of a paged list for the filters in `query` (an existing "?a=b" string without page parameters), up to the limit */
export async function fetchAllRows<T>(path: string, query: string): Promise<{ rows: T[]; total: number }> {
  const rows: T[] = [];
  let total = 0;
  const join = query && query.includes("?") ? "&" : "?";
  for (let page = 1; rows.length < EXPORT_LIMIT; page++) {
    const res = unwrapPage<T>(await api.get(`${path}${query}${join}page=${page}&page_size=100`));
    total = res.total;
    rows.push(...res.rows);
    if (res.rows.length === 0 || rows.length >= res.total) break;
  }
  return { rows: rows.slice(0, EXPORT_LIMIT), total };
}

/** Saves rows as a CSV that opens correctly in Excel (UTF-8 with a byte-order mark) */
export function downloadCsv<T>(filename: string, columns: [string, (row: T) => string | number | null | undefined][], rows: T[]) {
  const esc = (v: unknown) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const csv = [columns.map(([h]) => esc(h)).join(","), ...rows.map((r) => columns.map(([, f]) => esc(f(r))).join(","))].join("\r\n");
  const url = URL.createObjectURL(new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
